import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import CasesSection from './components/CasesSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { SEO } from '../../utils/seo';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '株式会社G11',
    url: siteUrl,
    logo: `${siteUrl}/logo.png`,
    description: '中小企業のM&A・事業承継を専門とする次世代型仲介プラットフォーム。休眠会社から稼働法人まで、豊富な案件をご紹介。',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '二日町12-25-2F',
      addressLocality: '仙台市青葉区',
      addressRegion: '宮城県',
      postalCode: '980-0000',
      addressCountry: 'JP'
    },
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'info@nextage.jp',
      contactType: 'Customer Service',
      availableLanguage: 'Japanese'
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="株式会社G11 | 中小企業M&A・事業承継の専門プラットフォーム"
        description="中小企業のM&A・事業承継を専門とする次世代型仲介プラットフォーム。休眠会社から稼働法人まで、豊富な案件をご紹介。スピード対応と専門家サポートで安心のM&A取引を実現します。"
        keywords="M&A,事業承継,会社売却,企業買収,休眠会社,稼働法人,中小企業,仙台,宮城"
        jsonLd={jsonLd}
      />
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <ServicesSection />
      <ProcessSection />
      <CasesSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
